import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { frappePost } from '@/lib/frappe';

export const scholarshipKeys = {
  all: ['scholarships'] as const,
  mine: () => [...scholarshipKeys.all, 'mine'] as const,
};

export function useMyScholarships() {
  return useQuery({
    queryKey: scholarshipKeys.mine(),
    queryFn: async () => {
      // Backend returns { success, scholarships: [...] }; unwrap so the
      // consumer can call .length / .map without TypeError (#38 sweep).
      const res = await frappePost<{ scholarships?: unknown[] } | unknown[]>(
        'hudan_lms.hudan_lms.doctype.hudan_scholarship.hudan_scholarship.get_my_scholarships'
      );
      if (Array.isArray(res)) return res;
      return (res as { scholarships?: unknown[] })?.scholarships ?? [];
    },
  });
}

export function useApplyScholarship() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: {
      scholarship_type: string;
      reason: string;
      reason_ar?: string;
      supporting_document?: string;
      monthly_income?: number;
      dependents?: number;
    }) =>
      frappePost(
        'hudan_lms.hudan_lms.doctype.hudan_scholarship.hudan_scholarship.apply_scholarship',
        data
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: scholarshipKeys.mine() });
    },
  });
}
